import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssessmentState } from '../reducers/assessment.reducer';
import { ASSESSMENT_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<AssessmentState>(ASSESSMENT_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: AssessmentState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: AssessmentState) => state.loading);
export const selectSaving = createSelector(selectState, (state: AssessmentState) => state.saving);
export const selectSaved = createSelector(selectState, (state: AssessmentState) => state.saved);
export const selectError = createSelector(selectState, (state: AssessmentState) => state.error);
export const selectAssessment = createSelector(selectState, (state: AssessmentState) => state.assessment);
